import type { AllRouteEndpoints } from "../routeTypes";
export const engagementCampaignsRestoreCampaignRetargetingDataCacheKeys: AllRouteEndpoints[] = [
  "/engagement/campaigns_data_v2",
];
